/* eslint-disable max-len */
import React, { SVGAttributes } from 'react';

export function PayByBank(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M2 18.5H18' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M18 6.5H2L9.3821 1.69845C9.56641 1.56888 9.7809 1.5 10 1.5C10.2191 1.5 10.4336 1.56888 10.6179 1.69845L18 6.5Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M3 9V16H5.5V9' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M8.75 9V16H11.25V9'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M15 9V16H17.5V9' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
